import React from 'react';
import {IBreadcrumb} from './breadcrumb.interface';
import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {BreadcrumbsItemComponent} from '../../../components/breadcrumbs/breadcrumbs-item/breadcrumbs-item.component';


export class NavigatableBreadcrumb implements IBreadcrumb {
  constructor(private _title: string, private _url: string, private services: IServiceFactoryExtended) {

  }

  private _navigate = () => {
    this.services.location.push(this._url);
  };

  render(position: number) {
    return (
      <BreadcrumbsItemComponent key={this._title} position={position} title={this._title} url={this._url} onClick={this._navigate}/>
    );
  }
}


